import { CanvasRoutes } from '@/configs/routes/types';

export const FoundationForecastingRoutes = {
  [CanvasRoutes.FoundationForecasting]: {
    name: 'Foundation Forecasting',
    path: '/forecasts',
    showInNavigation: true,
    showInBreadcrumbs: true,
  },
  [CanvasRoutes.FoundationForecastingHome]: {
    name: 'Home',
    path: '/forecasts/home',
    showInNavigation: true,
    showInBreadcrumbs: true,
  },
  [CanvasRoutes.ForecastExplorer]: {
    name: 'Forecast Explorer',
    path: '/forecasts/forecast-explorer',
    showInNavigation: true,
    showInBreadcrumbs: true,
  },
};
